/* @flow */
import * as React from 'react';
import AddButton from 'components/AddButton.jsx';
import AddFamilyModal from 'users/components/AddFamilyModal.jsx';
import Fieldset from 'components/Fieldset.jsx';
import Legend from 'components/Legend.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import UserParentChildRow from 'settings/components/UserParentChildRow.jsx';

import 'settings/components/styles/UserParentChildSection.scss';

type Props = {
  viewingUserId: ?number,
  relation: 'parent' | 'child',
  // $FlowIssue until https://github.com/apollographql/apollo-codegen/issues/159
  relatedUsers: [MinimalRelatedUserFragment],
  // $FlowIssue same
  pendingRelatedUsers: [MinimalRelatedUserFragment],
  permissions: Object,
  refetchProfile: () => {},
};

class UserParentChildSection extends React.Component<Props> {
  renderAddButton() {
    const { relation, permissions } = this.props;
    if (
      (relation === 'parent' && permissions.can_add_parent) ||
      (relation === 'child' && permissions.can_add_child)
    ) {
      return (
        <ModalTrigger
          modal={
            <AddFamilyModal
              selfId={this.props.viewingUserId}
              relationToAdd={this.props.relation}
              onAddFamilyMember={this.props.refetchProfile}
            />
          }>
          <AddButton className="UserParentChildSection-add-button" size="large">
            {this.props.relation === 'parent' ? 'Add your parent' : 'Add your child'}
          </AddButton>
        </ModalTrigger>
      );
    }
    return null;
  }

  render = () => {
    const titleText = this.props.relation === 'parent' ? 'Parents' : 'Children';
    return (
      <Fieldset>
        <Legend>{titleText}</Legend>
        <table className="UserParentChildSection-table">
          <tbody>
            {this.props.relatedUsers.map(u => (
              <UserParentChildRow
                key={u.id}
                relation={this.props.relation}
                relatedUser={u}
                viewingUserId={this.props.viewingUserId}
                onDelete={this.props.refetchProfile}
              />
            ))}
            {this.props.pendingRelatedUsers.map(u => (
              <UserParentChildRow
                key={u.id}
                relation={this.props.relation}
                relatedUser={u}
                viewingUserId={this.props.viewingUserId}
                onDelete={this.props.refetchProfile}
                pending
              />
            ))}
          </tbody>
        </table>
        {this.renderAddButton()}
      </Fieldset>
    );
  };
}

export default UserParentChildSection;
